(function () {
  'use strict';

  /* ---- Mobile nav drawer ---- */
  function initMobileNav() {
    var nav = document.getElementById('mobile-nav');
    var openBtn = document.getElementById('nav-open');
    var closeBtn = document.getElementById('nav-close');
    var overlay = nav ? nav.querySelector('.mobile-nav__overlay') : null;

    if (!nav || !openBtn) return;

    function openDrawer() {
      nav.classList.add('is-open');
      nav.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
    }

    openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---- Sticky / transparent header ---- */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var isTransparent = header.classList.contains('site-header--transparent');

    if (!isTransparent) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > 10);
      }, { passive: true });
      return;
    }

    /* For transparent mode, switch to solid once past the announcement bar */
    var annBar = document.querySelector('.announcement-bar');
    var threshold = annBar ? annBar.offsetHeight + 20 : 20;

    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initStickyHeader();
  });
})();